var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/core-js/object/define-property", "@babel/runtime-corejs2/core-js/object/define-properties", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor", "@babel/runtime-corejs2/core-js/object/get-own-property-symbols", "@babel/runtime-corejs2/core-js/object/keys", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "classnames", "prop-types", "react", "../../css", "../../propTypes", "../../Tracking", "../../UI/Interchange/Interchange"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/core-js/object/define-property"), require("@babel/runtime-corejs2/core-js/object/define-properties"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"), require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"), require("@babel/runtime-corejs2/core-js/object/keys"), require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("classnames"), require("prop-types"), require("react"), require("../../css"), require("../../propTypes"), require("../../Tracking"), require("../../UI/Interchange/Interchange"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.defineProperties, global.getOwnPropertyDescriptors, global.getOwnPropertyDescriptor, global.getOwnPropertySymbols, global.keys, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.classnames, global.propTypes, global.react, global.css, global.propTypes, global.Tracking, global.Interchange);
    global.Banner = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _defineProperties, _getOwnPropertyDescriptors, _getOwnPropertyDescriptor, _getOwnPropertySymbols, _keys, _es6Regexp, _es6Date, _es6Object, _construct, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty3, _classnames, _propTypes, _react, _css, _propTypes2, _Tracking, _Interchange) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty2(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _defineProperties = _interopRequireDefault(_defineProperties);
  _getOwnPropertyDescriptors = _interopRequireDefault(_getOwnPropertyDescriptors);
  _getOwnPropertyDescriptor = _interopRequireDefault(_getOwnPropertyDescriptor);
  _getOwnPropertySymbols = _interopRequireDefault(_getOwnPropertySymbols);
  _keys = _interopRequireDefault(_keys);
  _construct = _interopRequireDefault(_construct);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty3 = _interopRequireDefault(_defineProperty3);
  _classnames = _interopRequireDefault(_classnames);
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireWildcard(_react);
  _propTypes2 = _interopRequireDefault(_propTypes2);
  _Interchange = _interopRequireDefault(_Interchange);

  function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var bannerBreakpoints = {
    xsmall: 'banner',
    small: 'banner',
    medium: 'banner',
    large: 'banner',
    xlarge: 'banner',
    xxlarge: 'banner'
  };

  var Banner = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(Banner, _PureComponent);

    var _super = _createSuper(Banner);

    function Banner() {
      var _this;

      (0, _classCallCheck2.default)(this, Banner);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "getTeaser", function () {
        return _this.props.placeholder ? _objectSpread(_objectSpread({}, _this.props), {}, {
          images: [],
          url: '#',
          title: '-'
        }) : _this.props;
      });
      return _this;
    }

    (0, _createClass2.default)(Banner, [{
      key: "render",
      value: function render() {
        var _this$getTeaser = this.getTeaser(),
            className = _this$getTeaser.className,
            images = _this$getTeaser.images,
            placeholder = _this$getTeaser.placeholder,
            title = _this$getTeaser.title,
            tracking = _this$getTeaser.tracking,
            trackingEnabled = _this$getTeaser.trackingEnabled,
            url = _this$getTeaser.url;

        var onClick = trackingEnabled ? tracking : function () {};
        return /*#__PURE__*/_react.default.createElement("a", {
          className: (0, _classnames.default)('next-banner', className, {
            'is-placeholder': placeholder
          }),
          "aria-label": title,
          href: url,
          title: title,
          onClick: onClick
        }, /*#__PURE__*/_react.default.createElement(_Interchange.default, {
          images: images,
          title: title,
          breakpointFormat: bannerBreakpoints,
          hover: _css.hovers.basic
        }));
      }
    }]);
    return Banner;
  }(_react.PureComponent);

  Banner.propTypes = {
    className: _propTypes.default.string,
    images: _propTypes.default.arrayOf(_propTypes2.default.image).isRequired,
    placeholder: _propTypes.default.bool,
    title: _propTypes.default.string,
    tracking: _propTypes.default.func,
    trackingEnabled: _propTypes.default.bool,
    url: _propTypes.default.string.isRequired
  };
  Banner.defaultProps = {
    className: '',
    images: [],
    placeholder: false,
    tracking: function tracking() {
      if ('tc_vars' in global) {
        var _ref = global.tc_vars || {},
            page_name = _ref.page_name;

        if (page_name === 'Home_ARS') {
          // eslint-disable-line
          (0, _Tracking.send)({
            target: null,
            click_name: 'banner_concert',
            click_type: 'navigation'
          });
        }
      }
    },
    trackingEnabled: false,
    url: '#'
  };
  var _default = Banner;
  _exports.default = _default;
});